import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function BilirubinCalciumForm() {
  const [form, setForm] = useState({
    name: "",
    ageSex: "",
    doctor: "",
    date: "",

    serumBilirubin: "",
    serumBilirubinDirect: "",
    serumBilirubinIndirect: "",

    bloodUrea: "",
    creatinine: "",
    uricAcid: "",
    calcium: "",
    alkalinePhosphatase: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <>
      <div className="container my-3">
        <h3>Bilirubin, Calcium, Creatinine, Uric Acid, ALP FORM</h3>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Pt. Name:</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={form.name}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Age/Sex:</label>
            <input
              type="text"
              className="form-control"
              name="ageSex"
              value={form.ageSex}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Ref. by Dr.:</label>
            <input
              type="text"
              className="form-control"
              name="doctor"
              value={form.doctor}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Date:</label>
            <input
              type="date"
              className="form-control"
              name="date"
              value={form.date}
              onChange={handleChange}
            />
          </div>
        </div>

        <h5 className="mt-4">BIOCHEMISTRY</h5>
        <div className="mb-2">
          <label>Serum Bilirubin (Total) (mg/dl):</label>
          <input
            type="text"
            className="form-control"
            name="serumBilirubin"
            value={form.serumBilirubin}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label>Serum Bilirubin (Direct) (mg/dl):</label>
          <input
            type="text"
            className="form-control"
            name="serumBilirubinDirect"
            value={form.serumBilirubinDirect}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label>Serum Bilirubin (Indirect) (mg/dl):</label>
          <input
            type="text"
            className="form-control"
            name="serumBilirubinIndirect"
            value={form.serumBilirubinIndirect}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label>Blood Urea (mg/dl):</label>
          <input
            type="text"
            className="form-control"
            name="bloodUrea"
            value={form.bloodUrea}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label>Serum Creatinine (mg/dl):</label>
          <input
            type="text"
            className="form-control"
            name="creatinine"
            value={form.creatinine}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label>Serum Uric Acid (mg/dl):</label>
          <input
            type="text"
            className="form-control"
            name="uricAcid"
            value={form.uricAcid}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label>Serum Calcium (mg/dl):</label>
          <input
            type="text"
            className="form-control"
            name="calcium"
            value={form.calcium}
            onChange={handleChange}
          />
        </div>
        <div className="mb-2">
          <label>Alkaline Phosphatase (IU/L):</label>
          <input
            type="text"
            className="form-control"
            name="alkalinePhosphatase"
            value={form.alkalinePhosphatase}
            onChange={handleChange}
          />
        </div>

        <button className="btn btn-primary mt-3" onClick={() => window.print()}>
          🖨️ Print Report
        </button>
      </div>

      {/* Printable Report */}
      <div
        className="print-area container py-4"
        style={{ fontFamily: "Arial", fontSize: "14px" }}
      >
        <h2 className="text-center text-decoration-underline">
          BILIRUBIN, CREATININE, CALCIUM REPORT
        </h2>

        <div className="row mb-2">
          <div className="col-6">
            <strong>Pt. Name:</strong> {form.name}
          </div>
          <div className="col-6">
            <strong>Age/Sex:</strong> {form.ageSex}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-6">
            <strong>Ref. by Dr.:</strong> {form.doctor}
          </div>
          <div className="col-6">
            <strong>Date:</strong> {form.date}
          </div>
        </div>

        <h5 className="text-decoration-underline">BIOCHEMISTRY</h5>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>Serum Bilirubin (Total)</td>
              <td>{form.serumBilirubin} mg/dl (0.1 to 1.2 mg/dl)</td>
            </tr>
            <tr>
              <td>Serum Bilirubin (Direct)</td>
              <td>{form.serumBilirubinDirect} mg/dl (0.0 to 0.40 mg/dl)</td>
            </tr>
            <tr>
              <td>Serum Bilirubin (Indirect)</td>
              <td>{form.serumBilirubinIndirect} mg/dl (0.0 to 0.60 mg/dl)</td>
            </tr>
            <tr>
              <td>Blood Urea</td>
              <td>{form.bloodUrea} mg/dl (00 to 40 mg/dl)</td>
            </tr>
            <tr>
              <td>Serum Creatinine</td>
              <td>{form.creatinine} mg/dl (0.6 to 1.4 mg/dl)</td>
            </tr>
            <tr>
              <td>Serum Uric Acid</td>
              <td>{form.uricAcid} mg/dl (02 to 07 mg/dl)</td>
            </tr>
            <tr>
              <td>Serum Calcium</td>
              <td>{form.calcium} mg/dl (8.7 to 11.0 mg/dl)</td>
            </tr>
            <tr>
              <td>Alkaline Phosphatase (ALP)</td>
              <td>{form.alkalinePhosphatase} IU/L (20 to 140 IU/L)</td>
            </tr>
          </tbody>
        </table>

        <p className="text-end mt-4">
          <strong>*****END OF REPORTS*****</strong> &nbsp;&nbsp;&nbsp;&nbsp;
          Technologist
        </p>
      </div>
    </>
  );
}

export default BilirubinCalciumForm;
